import apiFetch from '../apiFetch'

export default function (documentId, token, file) {
  const formData = new FormData()
  formData.append(file.name, file)
  return apiFetch({ endPoint: `documentHistorical/${documentId}/Sheet`, method: 'POST', body: formData, token: token, fileBody: true })
}
